import React,{useEffect} from 'react';
import {connect} from 'react-redux';
import {logout} from '../store/authActions';
import Navbar from './Navbar';
import AutoLogout from './AutoLogout';
import AccountActions from './AccountActions';

const PortalPage = ({token,loading,logout}) => {
  useEffect(()=>{
    if(token===null) logout();
  //eslint-disable-next-line
  },[token]);

  return (
    <>
      { !loading 
          ? <>
              <Navbar title={'Account Portal'}/>
              <AutoLogout />
              <AccountActions />
            </>
          : <div className='progress valign-wrapper'> <div className='indeterminate'></div></div>
      }
    </>
  );
};

const matStoreToProps = state => ({
  token: state.auth.token,
  loading: state.auth.loading
});
export default connect(matStoreToProps,{logout})(PortalPage);
